import { render, staticRenderFns } from "./aiChatSettings.vue?vue&type=template&id=5a48cf84&scoped=true"
import script from "./aiChatSettings.vue?vue&type=script&lang=js"
export * from "./aiChatSettings.vue?vue&type=script&lang=js"
import style0 from "./aiChatSettings.vue?vue&type=style&index=0&id=5a48cf84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a48cf84",
  null
  
)

export default component.exports